import { useQuery } from 'react-query';

import { CommonWorkflowService } from '../api';

export const ListFileAttachmentsFromControlQuery =
  'ListFileAttachmentsFromControlQuery';

export const useListFileAttachmentsFromControlQuery = ({
  fileId,
}: {
  fileId?: string;
}) => {
  const { data: fileAttachments, isLoading } = useQuery(
    [ListFileAttachmentsFromControlQuery, { fileId }],
    async () => {
      if (!fileId) {
        return undefined;
      }

      const response =
        await CommonWorkflowService.listFileAttachmentsFromControlQuery({
          fileId,
        });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      suspense: true,
      staleTime: 1_000,
    },
  );

  return {
    fileAttachments,
    isLoading,
  };
};
